export function initSuggestionKeyboardNavigation() {
    let currentInput = null;
    let suggestionBox = null;
    let activeIndex = -1;

    function getItems() {
        if (!suggestionBox) return [];
        let items = [];
        let els = Array.from(suggestionBox.children);
        
        let validEls = els.filter(el => {
            // Ignore items that explicitly have 'd-none' class
            if (el.classList.contains('d-none') || el.style.display === 'none') return false;
            if (el.querySelector('img[src*="loder"]')) return false;
            if (el.innerText.trim().toLowerCase() === 'no record found') return false;
            if (el.innerText.trim().toLowerCase() === 'no results found') return false;
            return true;
        });
        
        validEls.forEach(el => {
            // If the element is a container holding column items (e.g. Globalsearchbar)
            let colChildren = Array.from(el.children).filter(child => child.className && typeof child.className === 'string' && child.className.includes('col-'));
            
            // Distinguish between a row that WRAPS grid items (like Globalsearchbar) 
            // and a row that IS the item (like RepairDetails).
            // An item usually has cursor-pointer or p-Suggestion, and in Globalsearchbar the wrapper is the ONLY valid element.
            if (el.classList.contains('row') && colChildren.length > 0 && !el.classList.contains('cursor-pointer') && !el.classList.contains('p-Suggestion') && validEls.length === 1) {
                // The actual items are the nested .col-* elements
                items.push(...colChildren);
            } else if (el.tagName === 'DIV' || el.tagName === 'LI') {
                items.push(el);
            }
        });
        
        return items;
    }

    function updateFocus(items, index) {
        items.forEach((item, i) => {
            if (i === index) {
                item.classList.add('keyboard-focused');
                item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
            } else {
                item.classList.remove('keyboard-focused');
            }
        });
    }

    let handledKeyDown = null;

    // Intercept keydown on the document in the capture phase to stop React from handling it
    document.addEventListener('keydown', (e) => {
        if (!e.target || e.target.tagName !== 'INPUT' || (e.target.type !== 'text' && e.target.type !== 'search')) return;

        // Dynamically find the suggestion box for the currently focused input
        let box = e.target.parentElement.querySelector('.SuggestionBoxDiv,.SearchDropDown-list');
        if (!box && e.target.parentElement.parentElement) {
            box = e.target.parentElement.parentElement.querySelector('.SuggestionBoxDiv,.SearchDropDown-list');
        }
        if (!box && e.target.parentElement.parentElement.parentElement) {
            box = e.target.parentElement.parentElement.parentElement.querySelector('.SuggestionBoxDiv,.SearchDropDown-list');
        }

        // If suggestion box doesn't exist or is hidden
        if (!box || box.classList.contains('d-none') || box.style.display === 'none') {
            if (currentInput === e.target) {
                currentInput = null;
                suggestionBox = null;
                activeIndex = -1;
            }
            return;
        }

        // If focus changed to a new input or box, reset state
        if (currentInput !== e.target || suggestionBox !== box) {
            currentInput = e.target;
            suggestionBox = box;
            activeIndex = -1;
        }

        if (['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) {
            const items = getItems();
            if (items.length === 0) return;

            handledKeyDown = e.key; // Track that we handled this specific keypress

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                e.stopPropagation();
                activeIndex = (activeIndex + 1) % items.length;
                updateFocus(items, activeIndex);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                e.stopPropagation();
                activeIndex = (activeIndex - 1 + items.length) % items.length;
                updateFocus(items, activeIndex);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                e.stopPropagation();
                if (activeIndex >= 0 && activeIndex < items.length) {
                    let target = items[activeIndex];
                    let clickTarget = target;
                    // If there's a checkbox inside, that's usually the primary action
                    let checkbox = target.querySelector('input[type="checkbox"]');
                    if (checkbox) {
                        clickTarget = checkbox;
                    } else {
                        // Look for an explicitly clickable inner element
                        // Many clickable rows are wrapped in extra divs, so we target the actual interactive layer
                        let specificClickable = target.querySelector('.cursor-pointer, [class*="schoolid"], .row, [class*="p-Suggestion"]');
                        if (specificClickable) {
                            clickTarget = specificClickable;
                        } else if (target.firstElementChild) {
                            clickTarget = target.firstElementChild;
                        }
                    }
                    
                    // Dispatch a mousedown event for React components that use onMouseDown instead of onClick
                    let mouseDownEvent = new MouseEvent('mousedown', {
                        bubbles: true,
                        cancelable: true,
                        view: window
                    });
                    clickTarget.dispatchEvent(mouseDownEvent);
                    
                    // Then trigger the standard click
                    clickTarget.click();
                    
                    // If we checked a box, this is likely a multi-select. 
                    // Do NOT close the box or blur the input so the user can continue selecting.
                    if (!checkbox) {
                        // Always blur to prevent the input from remaining focused and triggering another search
                        currentInput.blur();
                        
                        // Hide suggestion box by adding d-none just in case React doesn't do it immediately
                        if (suggestionBox) {
                            suggestionBox.classList.add('d-none');
                        }
                        
                        // Reset focus state
                        activeIndex = -1;
                        updateFocus(items, -1);
                    }
                }
            }
        }
    }, true);

    // If React triggers onKeyUp and tries to re-open the box or submit the form, stop it
    document.addEventListener('keyup', (e) => {
        if (!currentInput || document.activeElement !== currentInput) return;
        
        if (['ArrowDown', 'ArrowUp', 'Enter'].includes(e.key)) {
            if (handledKeyDown === e.key) {
                e.preventDefault();
                e.stopPropagation();
            }
            if (e.key === 'Enter') {
                handledKeyDown = null; // Reset tracker
            }
        }
    }, true);
}
